import { useNavigate } from 'react-router-dom';
import { useAccountId } from '../auth/useAccountId';
import { useUserPet } from '../hooks/useUserPet';
import { BALANCE_VERSION } from '@shared/domain/gameConstants';
import './SeasonPopup.css';
import { useT } from "../i18n/i18nContext";

const STORAGE_KEY = 'suikamon_season13_popup_dismissed';

interface SeasonPopupProps {
  onClose: () => void;
}

export function SeasonPopup({ onClose }: SeasonPopupProps) {
  const t = useT();
  const navigate = useNavigate();
  const { address: accountAddress } = useAccountId();
  const { hasPet } = useUserPet();

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    onClose();
  };

  const handleBattle = () => {
    handleClose();
    if (!accountAddress || !hasPet) {
      navigate('/');
      return;
    }
    navigate('/pvp-ranked');
  };

  return (
    <div className="season-popup-overlay" onClick={handleClose}>
      <div className="season-popup-card" onClick={(e) => e.stopPropagation()}>
        <button className="season-popup-close" onClick={handleClose} aria-label={t("common.action.close")}>✕</button>

        <img
          src="/season.png"
          alt={t("navigation.season.alt", { version: BALANCE_VERSION })}
          className="season-popup-image"
        />

        <div className="season-popup-body season-popup-body--compact">
          <p className="season-popup-label">{t("navigation.season.live")}</p>
          <h2 className="season-popup-title">{t("navigation.season.welcome", { version: BALANCE_VERSION })}</h2>
          <button className="season-popup-cta" onClick={handleBattle}>
            {t("navigation.season.cta")}
          </button>
        </div>
      </div>
    </div>
  );
}

// Disabled between seasons. Re-enable on next season launch by flipping
// SEASON_POPUP_ENABLED to true and bumping STORAGE_KEY to the new season.
const SEASON_POPUP_ENABLED = true;

// eslint-disable-next-line react-refresh/only-export-components -- intentional co-located export
export function shouldShowSeasonPopup(): boolean {
  if (!SEASON_POPUP_ENABLED) return false;
  return !localStorage.getItem(STORAGE_KEY);
}
